const MARKETS = {
    // North America
    US: ['en-US', 'es-US'],
    CA: ['en-CA', 'fr-CA'],
    MX: ['es-419'],
    // Central America and the Caribbean
    GT: ['es-419'],
    BZ: ['en-US', 'es-419'],
    SV: ['es-419'],
    HN: ['es-419'],
    NI: ['es-419'],
    CR: ['es-419'],
    PA: ['es-419'],
    DO: ['es-419'],
    JM: ['en-US'],
    TT: ['en-US'],
    BS: ['en-US'],
    BB: ['en-US'],
    HT: ['fr-FR'],
    AG: ['en-US'],
    AI: ['en-US'],
    AW: ['nl-NL', 'en-US'],
    BM: ['en-US'],
    BQ: ['nl-NL'],
    CU: ['es-419'],
    CW: ['nl-NL'],
    DM: ['en-US'],
    GD: ['en-US'],
    KN: ['en-US'],
    KY: ['en-US'],
    LC: ['en-US'],
    MS: ['en-US'],
    TC: ['en-US'],
    VC: ['en-US'],
    VG: ['en-US'],
    // South America
    CO: ['es-419'],
    VE: ['es-419'],
    EC: ['es-419'],
    PE: ['es-419'],
    BO: ['es-419'],
    CL: ['es-419'],
    AR: ['es-419'],
    UY: ['es-419'],
    PY: ['es-419'],
    BR: ['pt-BR'],
    GY: ['en-US'],
    SR: ['nl-NL'],
    FK: ['en-GB'],
    GS: ['en-GB'],
    // Western Europe
    GB: ['en-GB'],
    IE: ['en-GB'],
    FR: ['fr-FR'],
    MC: ['fr-FR'],
    BE: ['nl-NL', 'fr-FR'],
    NL: ['nl-NL'],
    LU: ['fr-FR', 'de-DE'],
    DE: ['de-DE'],
    AT: ['de-DE'],
    CH: ['de-DE', 'fr-FR'],
    LI: ['de-DE'],
    ES: ['es-ES'],
    AD: ['ca'],
    PT: ['pt-PT'],
    IT: ['it-IT'],
    SM: ['it-IT'],
    MT: ['en-GB'],
    GI: ['en-GB'],
    GG: ['en-GB'],
    JE: ['en-GB'],
    IM: ['en-GB'],
    VA: ['it-IT'],
    // Northern Europe
    DK: ['da-DK'],
    NO: ['no-NO'],
    SE: ['sv-SE'],
    FI: ['fi-FI', 'sv-SE'],
    IS: ['is-IS'],
    EE: ['et', 'ru-RU'],
    LV: ['lv', 'ru-RU'],
    LT: ['lt'],
    BV: ['no-NO'],
    // Central and Eastern Europe
    PL: ['pl-PL'],
    CZ: ['cs-CZ'],
    SK: ['sk'],
    HU: ['hu-HU'],
    SI: ['sl'],
    HR: ['hr'],
    BA: ['hr', 'sr'],
    RS: ['sr'],
    ME: ['sr'],
    MK: ['mk-MK'],
    AL: ['sq'],
    XK: ['sq'],
    RO: ['ro'],
    MD: ['ro', 'ru-RU'],
    BG: ['bg'],
    GR: ['el-GR'],
    CY: ['el-GR', 'en-GB'],
    UA: ['uk', 'ru-RU'],
    BY: ['be', 'ru-RU'],
    RU: ['ru-RU'],
    // Caucasus and Central Asia
    TR: ['tr-TR'],
    GE: ['ka-GE'],
    AM: ['hy-AM', 'ru-RU'],
    AZ: ['az-AZ'],
    KZ: ['kk', 'ru-RU'],
    KG: ['ky-KG', 'ru-RU'],
    UZ: ['ru-RU'],
    TJ: ['ru-RU'],
    TM: ['ru-RU'],
    // Middle East
    IL: ['iw-IL'],
    SA: ['ar'],
    AE: ['ar', 'en-GB'],
    QA: ['ar'],
    KW: ['ar'],
    BH: ['ar'],
    OM: ['ar'],
    YE: ['ar'],
    JO: ['ar'],
    LB: ['ar', 'fr-FR'],
    IQ: ['ar'],
    PS: ['ar'],
    AF: ['fa-AF'],
    IR: ['fa-IR'],
    // North Africa
    EG: ['ar'],
    LY: ['ar'],
    TN: ['ar', 'fr-FR'],
    DZ: ['ar', 'fr-FR'],
    MA: ['ar', 'fr-FR'],
    EH: ['ar'],
    SD: ['ar'],
    // Sub-Saharan Africa
    NG: ['en-GB'],
    GH: ['en-GB'],
    SL: ['en-GB'],
    LR: ['en-US'],
    GM: ['en-GB'],
    SN: ['fr-FR'],
    ML: ['fr-FR'],
    BF: ['fr-FR'],
    NE: ['fr-FR'],
    CI: ['fr-FR'],
    BJ: ['fr-FR'],
    TG: ['fr-FR'],
    CM: ['fr-FR', 'en-GB'],
    GA: ['fr-FR'],
    CG: ['fr-FR'],
    CD: ['fr-FR'],
    RW: ['en-GB', 'fr-FR'],
    ET: ['am'],
    KE: ['en-GB', 'sw'],
    UG: ['en-GB', 'sw'],
    TZ: ['sw', 'en-GB'],
    AO: ['pt-PT'],
    MZ: ['pt-PT'],
    ZM: ['en-GB'],
    ZW: ['en-GB'],
    MW: ['en-GB'],
    BW: ['en-GB'],
    NA: ['en-GB', 'af'],
    ZA: ['en-ZA', 'af'],
    MG: ['fr-FR'],
    MU: ['en-GB', 'fr-FR'],
    CV: ['pt-PT'],
    GW: ['pt-PT'],
    ST: ['pt-PT'],
    GN: ['fr-FR'],
    TD: ['fr-FR', 'ar'],
    CF: ['fr-FR'],
    BI: ['fr-FR'],
    GQ: ['es-ES', 'fr-FR'],
    MR: ['ar', 'fr-FR'],
    DJ: ['fr-FR', 'ar'],
    KM: ['fr-FR', 'ar'],
    ER: ['en-US', 'ar'],
    SO: ['ar', 'en-US'],
    SS: ['en-US'],
    LS: ['en-US'],
    SZ: ['en-US'],
    SC: ['en-US', 'fr-FR'],
    SH: ['en-GB'],
    IO: ['en-GB'],
    TF: ['fr-FR'],
    // South Asia
    IN: ['en-IN', 'hi-IN'],
    PK: ['ur', 'en-GB'],
    BD: ['bn-BD'],
    LK: ['si-LK', 'ta-IN'],
    NP: ['ne-NP'],
    BT: ['en-US'],
    MV: ['en-US'],
    // East Asia
    JP: ['ja-JP'],
    KR: ['ko-KR'],
    TW: ['zh-TW'],
    HK: ['zh-HK', 'en-GB'],
    MO: ['zh-HK'],
    MN: ['mn-MN'],
    CN: ['zh-CN'],
    // Southeast Asia
    SG: ['en-SG', 'zh-CN'],
    MY: ['ms-MY', 'en-GB'],
    BN: ['ms'],
    ID: ['id'],
    PH: ['fil', 'en-US'],
    TH: ['th'],
    VN: ['vi'],
    KH: ['km-KH'],
    LA: ['lo-LA'],
    MM: ['my-MM'],
    TL: ['pt-PT'],
    // Oceania
    AU: ['en-AU'],
    NZ: ['en-AU'],
    FJ: ['en-AU'],
    PG: ['en-AU'],
    SB: ['en-AU'],
    VU: ['en-AU', 'fr-FR'],
    TO: ['en-AU'],
    WS: ['en-AU'],
    FM: ['en-US'],
    KI: ['en-AU'],
    NR: ['en-AU'],
    TV: ['en-AU'],
    CK: ['en-AU'],
    NU: ['en-AU'],
    TK: ['en-AU'],
    NF: ['en-AU'],
    CX: ['en-AU'],
    CC: ['en-AU'],
    HM: ['en-AU'],
    PN: ['en-GB'],
    UM: ['en-US'],
    // Antarctica: listed by Google Play among the 'Rest of the world' locations.
    AQ: ['en-US'],
};
export const MARKET_LOCALES = Object.entries(MARKETS).flatMap(([market, locales]) => locales.map((locale) => ({ market, locale })));
export const MARKETS_WITH_PLAY = Object.keys(MARKETS);
/**
 * The language a Play tag is written in, which is what decides whether content is a
 * translation. Regional English, Spanish or Portuguese is one language; Simplified and
 * Traditional Chinese are not, because a reader of one cannot be assumed to read the
 * other. `iw` and `he` are the same Hebrew.
 */
export function languageOf(locale) {
    const [primary = '', ...rest] = locale.replaceAll('_', '-').split('-');
    const language = primary.toLowerCase();
    if (language === 'zh') {
        // A script said outright decides; only without one does the region stand for it.
        const subtags = rest.map((one) => one.toLowerCase());
        if (subtags.includes('hant'))
            return 'zh-Hant';
        if (subtags.includes('hans'))
            return 'zh-Hans';
        return subtags.some((one) => ['tw', 'hk', 'mo'].includes(one)) ? 'zh-Hant' : 'zh-Hans';
    }
    if (language === 'he')
        return 'iw';
    if (language === 'tl')
        return 'fil';
    if (language === 'nb')
        return 'no';
    return language;
}
/** Every language some Market Locale reads, in the order of the market table. */
export const MARKET_LANGUAGES = [...new Set(MARKET_LOCALES.map(({ locale }) => languageOf(locale)))];
//# sourceMappingURL=market-locales.js.map